'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z' });

var Details = function Details(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Details = (0, _pure2.default)(Details);
Details.muiName = 'SvgIcon';

exports.default = Details;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Details.js
// module id = 2308
// module chunks = 0